import React from 'react';
import { Grid, makeStyles } from '@material-ui/core';
import { InfoCard } from '@backstage/core-components';
import { useEntity } from '@backstage/plugin-catalog-react';

const useStyles = makeStyles({
  cardContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
});

/** @public */
export const EntityQRCode = () => {
  const classes = useStyles();
  const { entity } = useEntity();
  const qrCode = entity?.metadata?.qrCode as string;

  return qrCode ? (
    <Grid item xs={12}>
      <InfoCard
        title="Download Sample App via QR Code"
        className={classes.cardContainer}
      >
        <img src={qrCode} alt="Download me!" width={200} />
      </InfoCard>
    </Grid>
  ) : (
    <></>
  );
};
